import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { pushMapExpanded } from 'src/routes/SearchPage/components/YandexMapsSearch/analytics';
import { Expand as ExpandIcon } from '@lt/components/icons-react/rebrand';

import type { ToggleMapButtonProps as Props } from './types';
import styles from './toggleMapButtonMobile.module.css';

const ToggleMapButtonMobile = ({
  toggleHandler,
  mapView,
  className,
}: Props) => {
  const { t } = useTranslation();

  const handleClick = () => {
    toggleHandler();
    pushMapExpanded(mapView);
  };

  return (
    <button
      className={cn(className, styles.button)}
      type="button"
      onClick={handleClick}
    >
      <ExpandIcon height={12} />
      <span>{t('map.controls.expand')}</span>
    </button>
  );
};

export default ToggleMapButtonMobile;
